import { createFileRoute } from '@tanstack/react-router';

import { SecretaryApprovalPage } from '@/features/secretary/SecretaryPages.js';

export const Route = createFileRoute('/secretary/approvals/$approvalId')({
  component: ApprovalRoute,
});

function ApprovalRoute() {
  const { approvalId } = Route.useParams();
  return <SecretaryApprovalPage approvalId={approvalId} />;
}
